import { Component, OnInit, Renderer2 } from "@angular/core";
import { AnalyticsService } from "./@core/utils/analytics.service";
import { Event, NavigationEnd, NavigationStart, Router } from "@angular/router";
import { Title } from "@angular/platform-browser";
import { CspService } from "./services/csp.service";

@Component({
  selector: "ngx-app",
  template: "<router-outlet></router-outlet>",
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private titleService: Title,
    private analytics: AnalyticsService,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    // Apply dynamic CSP based on environment
    CspService.applyCSP();

    let currentEnv = window.location.origin;
    if (currentEnv.startsWith("https://stage")) {
      this.titleService.setTitle("WorktualizeStage");
    } else {
      this.titleService.setTitle("Worktualize");
    }
    this.analytics.trackPageViews();

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        // Add Google Analytics tracking for each page load
        gtag("config", "GTM-PKKSJ9XB", { page_path: event.urlAfterRedirects });
        if (event.url === "/auth/login") {
          sessionStorage.clear();
        } else if (event.url === "/auth/download") {
          this.renderer.addClass(document.body, "homelogin");
        } else if (event.url === "/auth/requestpass") {
          this.renderer.addClass(document.body, "homelogin");
        } else {
          this.renderer.removeClass(document.body, "homelogin");
        }
      }
    });
  }
}
